import React from 'react'
import useFetch from '../common/useFetch';

// import appSettings from '../assets/app-settings.json';

function RequestList() {

    // const url = "http://localhost:55501/api/downloads/requests";
    const appSettings = window.AppConfigSettings;
    const url = appSettings.baseApiUrl + "/downloads/requests";
    console.log("[url]", url);

    const {data: requests, error, isPending} = useFetch(url);

    return (
        <div>
            <h2>Review Requests</h2>
            <div className="requests">
                {isPending && <div>Loading...</div>}
                {error && <div>{error}</div>}
                { requests && requests.map((request) => (
                    <div style={{borderColor:"lightgray", borderBottomStyle: "solid", margin:"15px"}}>
                        <p><b>Request by:</b> {request.userFirstName} {request.userLastName}</p>
                        <p><b>Organization:</b> {request.userCompany}</p>
                        {/* <p>profileDataIDs: {request.profileDataIDs}</p>
                        <p>geoDataIDs: {request.geoDataIDs}</p> */}
                    </div>
                ))}
                { requests && !requests.length && <div>No requests to review.</div> }
            </div>
        </div>
    )
}

export default RequestList
